export const socialLinks = {
  youtube: 'https://www.youtube.com/@Molwe_ru',
  vk: 'https://vk.com/ficly',
  telegram: 'https://t.me/molweru',
  pinterest: 'https://ru.pinterest.com/molweru',
  about: '/about',
};
